import { ActionTypes } from "./actions.js";
import { getInitialState } from "./state.js";
const initialState = getInitialState();
const reducer = (state = initialState, action) => {
    switch (action.type) {
        case ActionTypes.setTravelPurpose:
            return {
                ...state,
                travelPurpose: action.payload
            };
        default:
            return state;
    }
};
export { reducer, getInitialState };
